module.exports = __webpack_public_path__ + "static/media/tablet_never_logged_in_icon.894272b2.png";